const supportedTypes = /* @__PURE__ */ new Set([
  "user",
  "team",
  "team_users",
  "dashboard",
  "event_definition",
  "notification",
  "search",
  "stream",
  "search_filter",
  "role",
  "output",
  "collection",
  "collection_entities",
  "builtin-team"
]);
const typePrefixCornerCasesMap = {
  event_definition: "eventdefinitions:",
  notification: "eventnotifications:",
  search: "view:",
  dashboard: "view:"
};
const standardEntityPermissionsMapper = {
  mapForIdAndType(_id, _type) {
    return void 0;
  },
  mapForType(type) {
    var _a;
    if (supportedTypes.has(type)) return (_a = typePrefixCornerCasesMap[type]) != null ? _a : `${type}s:`;
    return void 0;
  }
};
export default standardEntityPermissionsMapper;
